export const DEFAULT_LANG = 'en-US';
export const APP_LANGS = [
  'de-DE',
  'en-US',
  'es-ES'
];



// WEBPACK FOOTER //
// ./src/components/App/App.constants.js